export default __webpack_public_path__ + "static/media/upload.4d5d5e81.svg";